import { Resource } from 'kolibri.lib.apiResource';

export const SignUpResource = new Resource({
  name: 'signup',
});
